import { HttpErrorResponse } from '@angular/common/http';
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { debounceTime, skip, Subject, take, takeUntil } from 'rxjs';
import { CustomizerSettingsService } from 'src/app/components/customizer-settings/customizer-settings.service';
import {
    getAllMailSidebarMailBox,
    getMailSidebarMailBox,
    MailCommon,
} from 'src/app/core/constants/mail-box-const';
import { permissionEntity } from 'src/app/core/constants/permission';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { random3DigitId } from 'src/app/core/helpers/helperfunc';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { MailBoxService } from 'src/app/core/services/mail-box/mail-box.service';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { CreateMailComponent } from 'src/app/views/mail-box/create-mail/create-mail.component';

@Component({
    selector: 'app-mail-sidebar-mail-box',
    templateUrl: './mail-sidebar.component.html',
    styleUrls: ['./mail-sidebar.component.scss'],
})
export class MailSidebarComponentMailBox
    implements OnInit, OnChanges, OnDestroy {
    mail_sidebar = getMailSidebarMailBox(this._localStorageService);
    allMailSidebar = getAllMailSidebarMailBox(this._localStorageService);
    @Input() dashboard_counts: any;
    @Output() trigger_menu_change: EventEmitter<any> = new EventEmitter();
    @Output() trigger_folder: EventEmitter<any> = new EventEmitter();
    @Output() trigger_mail_select: EventEmitter<any> = new EventEmitter();

    public routerUrl = urlRoutes;
    selected_menu: any;
    permissions_entity = permissionEntity;
    show_folder_input: boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject();
    user_details: any;
    panelOpenState = false;
    domain_sidebar: any;
    selected_domain: any;
    selected_domain_index: number;

    folder_name: string = '';
    folder_action_type: string = '';
    selected_folder_id: any;
    selected_folder_domain: string = '';
    isGlobalMail: boolean = false;
    isMMR: boolean = false;
    getDC: boolean = false;
    constructor(
        public themeService: CustomizerSettingsService,
        private _navigationService: NavigationService,
        public dialog: MatDialog,
        private _loaderService: LoaderService,
        private _mailBoxService: MailBoxService,
        private _authService: AuthenticationService,
        private _localStorageService: LocalStorageService,
        private _toasterService: ToasterService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        // if (changes['c']?.currentValue) {
        //   this.dashboard_counts = changes['dashboard_counts']?.currentValue;
        //   if (this.dashboard_counts) {
        //     this.domain_sidebar = this.dashboard_counts.map((element: any, index: number) => {
        //       return {
        //         domain: element.domain,
        //         mail: element.mail,
        //         username:element.mail.match(/^[^@]+/)[0],
        //         totalFolderCount: element?.totalFolderCount,
        //         sub_menus: this.mail_sidebar.map(items => {
        //           return {
        //             id: items.id,
        //             menu: items.menu,
        //             icon: items.icon,
        //             count: element[items.count_label]
        //           }
        //         })
        //       }
        //     })
        //   }
        //   let stored_domain = JSON.parse(localStorage.getItem(MailCommon.selected_domain))
        //   if (stored_domain) {
        //     this.selected_domain = stored_domain;
        //     this.selected_domain_index = this.dashboard_counts?.findIndex(ele => ele.mail === this.selected_domain?.mail);
        //   }
        // }
    }

    ngOnInit(): void {
        console.log(this.mail_sidebar);
        let stored_domain = JSON.parse(
            localStorage.getItem(MailCommon.selected_domain)
        );
        // let switchUserDetails = this._localStorageService.getSwitchedUserDetails();
        this.user_details = this._authService.getLoginUserDetails();       

        if (this.user_details?.universitiesURM || this.user_details?.caseOwner) {
            const hasPersonalMail = this.user_details?.inboxMail?.some(mail => mail.isPersonal === "true");  
            if (hasPersonalMail) {
                this.mail_sidebar.splice(1, 0,
                    { id: 0, menu: 'Personal Mails', icon: 'ri-mail-line', count_label: 'totalMyMails', count: 0, myMails: true }
                );
            }
        }       

        this.mail_sidebar = [...new Set(this.mail_sidebar)];

        if (this.user_details && this.user_details?.inboxMail) {            
            this.isGlobalMail = false;
            this.mail_sidebar = [...new Set(this.mail_sidebar)];

            // Map each inbox mail to domain sidebar with filtered sub_menus
            this.domain_sidebar = this.user_details?.inboxMail?.map((item) => ({
                ...item,
                username: item.mail.match(/^[^@]+/)[0],
                sub_menus: this.mail_sidebar.map((menu) => ({
                    ...menu,
                    count: 0,
                })).filter(menu => {
                    // Keep all menus except Personal Mails unless isPersonal is true
                    if (menu.myMails) {
                        return item.isPersonal === "true";
                    }
                    return true;
                }),
                totalFolderCount: item.totalFolderCount || [],
                isGlobalMail: false
            }));

            // Handle multiple inboxes
            if (this.user_details?.inboxMail?.length > 1) {
                if (this.user_details?.universitiesURM || this.user_details?.caseOwner) {
                    this._mailBoxService.setSelectedMailType = true;
                    this.allMailSidebar = [...new Set(this.allMailSidebar)];
                }

                this.isGlobalMail = true;
                const domains = [...new Set(this.user_details?.inboxMail?.map((item) => item.domain))]?.join(',');

                // Add "All Mails" to the beginning of domain_sidebar
                this.domain_sidebar.unshift({
                    mail: this.user_details?.inboxMail?.map((item) => item?.mail).join(','),
                    domain: domains,
                    username: "All Mails",
                    sub_menus: this.allMailSidebar.map((menu) => ({
                        ...menu,
                        count: 0,
                    })),
                    totalFolderCount: [],
                    isGlobalMail: true
                });
            } else {
                // Single inbox handling
                this.isGlobalMail = true;
                this._mailBoxService.setSelectedMailType = true;
                this.domain_sidebar[0] = {
                    ...this.domain_sidebar[0],
                    isGlobalMail: true
                };
            }

            // Set initial selections
            this.selected_menu = this.mail_sidebar[0];
            this._mailBoxService.setSelectedMailType = this.domain_sidebar[0]?.isGlobalMail;
            this.getCounts(stored_domain);
        }

        // Subscribe to mail count updates
        this._mailBoxService.updateMailCount.pipe(skip(1),takeUntil(this._unsubscribeAll)).subscribe({
            next: (res) => {
                let stored_domain = JSON.parse(
                    localStorage.getItem(MailCommon.selected_domain)
                );
                if(!this.getDC){
                    this.getCounts(stored_domain);
                }
            },
        });
    }

    getCounts(stored_domain: any) {
        if (stored_domain) {
            this.selected_domain = stored_domain;
            this.selected_domain_index = this.domain_sidebar?.findIndex(
                (ele) => ele.mail === this.selected_domain?.mail
            );
            const { mail, domain } = this.selected_domain;
            this.getDashboardCountsV2(mail, domain, this.selected_domain_index);
        }
    }

    loadMail(menu: any, sidebar: any, type?: string) {
        let stored_domain = JSON.parse(
            localStorage.getItem(MailCommon.selected_domain)
        );
        const selectedDomain = { domain: sidebar?.domain, mail: sidebar?.mail };
        this._localStorageService.setKey(
            MailCommon.selected_domain,
            JSON.stringify({ ...selectedDomain })
        );
        this.selected_menu = menu;
        if (stored_domain?.mail !== sidebar?.mail) {
            this._mailBoxService.mailFoldersData = undefined;
        }
        this.trigger_menu_change.emit({ ...menu, type });
    }

    setMailType(index: number) {
        this._mailBoxService.setSelectedMailType = this.domain_sidebar[index].isGlobalMail;
        this.isGlobalMail = this.domain_sidebar[index].isGlobalMail;
    }

    navigateTo(path: string) {
        let url = `${urlRoutes.mainLayout}/${urlRoutes.university_communications}/${urlRoutes.mail_box}/${path}`;
        this._navigationService.routeToPath(url);
    }

    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    public composeMail(): void {
        const dialogRef = this.dialog.open(CreateMailComponent, {
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: '100%',
            width: '100%',
            enterAnimationDuration: '300ms',
            exitAnimationDuration: '100ms',
            data: {},
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
            }
        });
    }

    createFolder(domain, mail) {
        this.folder_action_type = 'add';
        this.show_folder_input = true;
        this.folder_name = ''; // Reset folder name for a new folder
        this.selected_folder_domain = domain;
    }

    editFolder(index: number, domain: string, folder: any) {
        this.selected_folder_domain = domain;
        this.folder_action_type = 'edit';
        this.show_folder_input = true;
        this.selected_folder_id = folder?.id;
        this.folder_name = folder?.name;
        // this.submitFolder();
    }

    submitFolder(domain: any, mail?: any) {
        // let payload = this.user_details?.mailAllotmentFolders;
        // let allFolders = [
        //     ...this.user_details?.mailAllotmentFolders,
        //     ...this.domain_sidebar[0]?.totalFolderCount,
        // ];
        // let payload = this.user_details?.mailAllotmentFolders;
        // let find_folder_index = allFolders?.find(
        //     (folders) => folders?.id === this.selected_folder_id
        // );
        let payload = null;
        if (!this.folder_name.trim()) {
            this._toasterService.showError(
                'Error',
                "Folder name can't be empty"
            );
            return;
        }

        if (this.folder_action_type === 'edit') {
            payload = {
                name: this.folder_name.trim(),
            };
        } else {
            payload = {
                name: this.folder_name.trim(),
                domain: domain,
                status: true,
                email: mail,
            };
            // if (payload?.length) {
            // }
            // else {
            //     payload = [
            //         {
            //             id: String(random3DigitId()),
            //             name: this.folder_name,
            //             domain: domain,
            //             status: true,
            //         },
            //     ];
            // }
        }
        // return;
        this._loaderService.showLoader();
        // this._mailBoxService
        //     .createFolder(this.user_details.id, {
        //         payload,
        //     })
        if (this.folder_action_type === 'edit') {
            this._mailBoxService
                .updateMailFolder(this.selected_folder_id, payload)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    (res: any) => {
                        if (res && res?.statusCode === 200) {
                            this.folder_name = '';
                            this.show_folder_input = false;
                            this._loaderService.hideLoader();
                            const index = this.domain_sidebar?.findIndex(
                                (ele) => ele.mail === mail
                            );
                            if (res?.data?.id) {
                                this.getDashboardCountsV2(mail, domain, index);
                            } else {
                                this._toasterService.showError(
                                    'Error',
                                    res?.data
                                );
                            }
                            return;
                            this.user_details['mailAllotmentFolders'] =
                                res?.data?.mailAllotmentFolders;
                            this._localStorageService.setKey(
                                'user_details',
                                JSON.stringify(this.user_details)
                            );
                            if (this.selected_domain?.domain !== domain) {
                                this._localStorageService.setKey(
                                    MailCommon.selected_domain,
                                    domain
                                );
                                this.trigger_menu_change.emit(
                                    this.selected_menu
                                );
                            } else {
                                this.trigger_folder.emit(true);
                            }
                        }
                        this._mailBoxService.checkFronSidebar.next(true);
                        this._loaderService.hideLoader();
                    },
                    (err) => {
                        this._loaderService.hideLoader();
                    }
                );
        } else {
            this._mailBoxService
                .addNewMailFolder(payload)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    (res: any) => {
                        if (res && res?.statusCode === 200) {
                            const index = this.domain_sidebar?.findIndex(
                                (ele) => ele.mail === mail
                            );

                            this.folder_name = '';
                            this.show_folder_input = false;
                            this._loaderService.hideLoader();
                            if (res?.data?.id) {
                                this.getDashboardCountsV2(mail, domain, index);
                            } else {
                                this._toasterService.showError(
                                    'Error',
                                    res?.data
                                );
                            }
                            return;
                            this.user_details['mailAllotmentFolders'] =
                                res?.data?.mailAllotmentFolders;
                            this._localStorageService.setKey(
                                'user_details',
                                JSON.stringify(this.user_details)
                            );
                            if (this.selected_domain?.domain !== domain) {
                                this._localStorageService.setKey(
                                    MailCommon.selected_domain,
                                    domain
                                );
                                this.trigger_menu_change.emit(
                                    this.selected_menu
                                );
                            } else {
                                // this.trigger_folder.emit(true);
                            }
                            this.getDashboardCountsV2(mail, domain);
                        }
                        this._mailBoxService.checkFronSidebar.next(true);
                        this._loaderService.hideLoader();
                    },
                    (err) => {
                        this._loaderService.hideLoader();
                    }
                );
        }
    }

    toggleMailPanel(
        isOpen: boolean,
        sidebar: any = null,
        index?: number
    ): void {
        this._mailBoxService.setSelectedMailType = this.domain_sidebar[index].isGlobalMail;
        this.isGlobalMail = this.domain_sidebar[index].isGlobalMail;
        if (isOpen && this.selected_domain_index !== index) {
            // const selectedDomain = {
            //     domain: sidebar?.domain,
            //     mail: sidebar?.mail,
            // };
            // this._localStorageService.setKey(
            //     MailCommon.selected_domain,
            //     JSON.stringify({ ...selectedDomain })
            // );

            // // this.selected_domain_index = index;

            // this.selected_domain_index = this.domain_sidebar?.findIndex(
            //     (ele) => ele.mail === sidebar?.mail
            // );           

            this.getDashboardCountsV2(sidebar?.mail, sidebar?.domain, index);
        }
    }

    ///? fetching all email details
    getDashboardCountsV2(email?: string, domain?: string, index?: number) {
        this.getDC = true;
        const userDetails = this._authService.getLoginUserDetails();
        if (userDetails && userDetails?.inboxMail?.length > 0) {
            const userType = (index === 0 && this.isGlobalMail) ? (userDetails?.universitiesURM && 'urm' || userDetails?.caseOwner && 'caseOwner') : '';
            const universityIds = (index === 0 && this.isGlobalMail) ? userDetails?.universityIds.join(',') : ''

            this._mailBoxService.getDashboardCountsV2(email, domain, userType, universityIds, this.domain_sidebar[index]?.isPersonal === 'true').pipe(debounceTime(300), take(1),takeUntil(this._unsubscribeAll)).subscribe(
                (res) => {
                    this.getDC = false;
                    if (
                        res?.statusCode === 200 &&
                        res?.success &&
                        res?.data &&
                        res?.data?.length > 0
                    ) {
                        const mailData = res.data;

                        const mailSubMenu =
                            this.domain_sidebar[index]?.sub_menus;
                        this.domain_sidebar[index].totalFolderCount =
                            mailData[0]?.totalFolderCount; //? getting folders

                        let stored_domain = JSON.parse(
                            localStorage.getItem(MailCommon.selected_domain)
                        );
                        if (stored_domain && stored_domain?.mail === email) {
                            this._mailBoxService.mailFoldersData =
                                mailData[0]?.totalFolderCount || [];
                        }

                        if (mailData && mailSubMenu) {
                            const updatedSubMenus = mailSubMenu.map((menu) => {
                                const matchingMail = mailData.find(
                                    (mail) => mail.domain === domain
                                );
                                return {
                                    ...menu,
                                    count: matchingMail
                                        ? matchingMail[menu.count_label] || 0
                                        : 0,
                                };
                            });

                            this.domain_sidebar[index].sub_menus =
                                updatedSubMenus;
                        }
                    }
                },
                (err: HttpErrorResponse) => {
                    this.getDC = false;
                    console.log('Error fetching dashboard counts:', err);
                }
            );
        }
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
